import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || "en");

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
  ];

  // Sync selectedLanguage with i18n language on mount and when language changes
  useEffect(() => {
    const currentLang = i18n.language?.split("-")[0] || "en";
    setSelectedLanguage(currentLang);
    
    const handleLanguageChanged = (lng) => {
      const langCode = lng?.split("-")[0] || "en";
      setSelectedLanguage(langCode);
    };

    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n]);

  const changeLanguage = (lng) => {
    setSelectedLanguage(lng);
    i18n.changeLanguage(lng);
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200">
        <i className="far fa-globe mr-2 text-primary-600" />
        <span className="text-gray-900">
          {languages.find((lang) => lang.code === selectedLanguage)?.label || "English"}
        </span>
        <i className="fas fa-chevron-down ml-2 text-gray-500 text-xs" />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-40 origin-top-right bg-white border border-gray-200 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden z-50">
          <div className="py-1">
            {languages.map((lang) => (
              <Menu.Item key={lang.code}>
                {({ active }) => (
                  <button
                    onClick={() => changeLanguage(lang.code)}
                    className={`flex items-center w-full text-left px-4 py-2 text-sm transition-colors duration-150 ${
                      selectedLanguage === lang.code
                        ? "bg-primary-50 text-primary-700 font-medium"
                        : active
                        ? "bg-gray-50 text-gray-900"
                        : "text-gray-700 hover:bg-gray-50"
                    }`}
                  >
                    <span className="flex-grow">{lang.label}</span>
                    {selectedLanguage === lang.code && (
                      <i className="far fa-check text-primary-600 ml-2" />
                    )}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default LanguageSwitcher;
